import React from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import App from "./App.jsx";
import loadingManager from "./utils/AppLoadingManager"; // Ensure path is correct

// --- Suppress specific warnings (Optional) ---
// const originalWarn = console.warn;
// console.warn = (message, ...args) => {
//   if (message.includes("React Router Future Flag Warning")) { return; }
//   originalWarn(message, ...args);
// };

// --- Helper function to check if path requires app loading ---
const requiresAppLoading = (pathname) => {
  const publicPaths = [
    "/",
    "/login",
    "/plans",
    "/request-reset",
    "/reset-password",
  ];
  return !publicPaths.some(
    (publicPath) =>
      pathname === publicPath ||
      (publicPath !== "/" && pathname.startsWith(publicPath + "/"))
  );
};

// --- Determine if loading is needed ---
const needsLoading = requiresAppLoading(window.location.pathname);
// console.log(
//   `main.jsx: Current path "${window.location.pathname}", needsLoading: ${needsLoading}`
// );

// --- Initialize Loading Manager CONDITIONALLY ---
if (needsLoading) {
  loadingManager.setProgress(5, "Initializing...");
  // console.log("main.jsx: Loading Manager initialized for app route.");
  // loadingManager.completeStep("app-init");
}
// else {
//   console.log("main.jsx: Skipping Loading Manager init for public route.");
// }

// --- Import CSS ---
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./assets/css/themes.css";
import "./assets/css/CalendarGrid.css";
import "./assets/css/connectome-dark-blue-theme.css";
import "./assets/css/connectome-dark-theme.css";
import "./assets/css/connectome-styles.css";
import "./assets/css/Tiptap.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/LandingPage.css";

// --- Get DOM Elements ---
const rootElement = document.getElementById("root");
const initialLoader = document.getElementById("initial-loader"); // <<< FIND IT HERE, EARLY!

// --- Mount React App ---
if (rootElement) {
  // --- Handle Initial Static Loader FIRST ---
  if (initialLoader) {
    if (needsLoading) {
      // APP ROUTE: Hide with delay
      // console.log(
      //   "main.jsx: Scheduling delayed hide for initial static loader (app route)."
      // );
      setTimeout(() => {
        initialLoader.classList.add("hidden");
        initialLoader.addEventListener(
          "transitionend",
          () => {
            // console.log("Static loader transition ended, removing element.");
            initialLoader.remove();
          },
          { once: true }
        );
      }, 100); // Adjust delay as needed
    } else {
      // PUBLIC ROUTE: Start fade immediately
      // console.log(
      //   "main.jsx: Hiding initial static loader (immediately for public route)."
      // );
      initialLoader.classList.add("hidden");
      initialLoader.addEventListener(
        "transitionend",
        () => {
          // console.log("Static loader transition ended, removing element.");
          initialLoader.remove();
        },
        { once: true }
      );
      // OR remove instantly: initialLoader.remove();
    }
  } else {
    // This warning *shouldn't* appear now, but keep it for debugging
    console.warn(
      "main.jsx: Initial static loader element (#initial-loader) not found *before* React render."
    );
  }

  // --- NOW Render React App ---
  ReactDOM.createRoot(rootElement).render(
    // <React.StrictMode> // Optional
    <>
      <App />
      <ToastContainer
        autoClose={1500}
        position="bottom-right"
        theme="colored"
      />
    </>
    // </React.StrictMode>
  );
} else {
  console.error(
    "CRITICAL: Failed to find the root element (#root). React app cannot be mounted."
  );
  // Optional: If root isn't found, but loader exists, maybe remove it?
  if (initialLoader) {
    console.warn("Root element not found, removing dangling initial loader.");
    initialLoader.remove();
  }
}
